import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { environment } from '@env/environment';
import { LoginService } from 'src/app/features/login/login.service';

export const MainLayoutResolver: ResolveFn<any> = () => {
  if (environment.MOCK_DATA) {
    return true;
  }

  const loginService = inject(LoginService);
  try {
    if (window.location.href.includes('code')) {
      return loginService.getB2CCode();
    }

    const token = loginService.getAccessToken();
    if (!token || loginService.isTokenExpired(token)) {
      return loginService.refreshToken();
    }
  } catch (err) {
    console.error(err);
  }
  return true;
};
